export var cibFramer = ["32 32", "<path d='M5.333 0h21.333v10.667h-10.667zM5.333 10.667h10.667l10.667 10.667h-21.333zM5.333 21.333h10.667v10.667z'/>"];
